import {BrickSnake2000Symbol} from "./BrickSnake2000Symbol";
import {SymbolArgs} from "./BrickSnake2000Symbol"
import {SpineGSAPWrapper} from "../../animation/SpineGSAPWrapper";
import {BrickSnake2000} from "../../BrickSnake2000";
import {BrickSnake2000GameAssets} from "../../BrickSnake2000GameAssets";
import {gsap} from "gsap";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";

export class MaxWinSymbol extends BrickSnake2000Symbol {
    private reelNumber:number;
    constructor(args:SymbolArgs) {
        args.suffix = args.symbolName == "MW" ? args.reelID == 0 ? "_1" : "_2" : "";
        super(args);
        this.reelNumber = args.reelID == 0 ? 1 : 2;

        this.view.removeChild(this.winAnimation);
        this.winAnimation = new PIXI.spine.Spine(BrickSnake2000.assetLoader.getSpineAsset(BrickSnake2000GameAssets.MAX_WIN));
        this.view.addChild(this.winAnimation);
    }

    public getLandAnimation():gsap.core.Timeline {
        return BrickSnake2000.model.data.mode == GameMode.NORMAL
               ? this.baseGameLand()
               : this.freespinsLand()
    }

    private baseGameLand():gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.winAnimation.alpha = 1;
                this.mainSprite.alpha = 0;
                this.moveToWinLayer();
            })
            .add(SpineGSAPWrapper.createTimeline(this.winAnimation, 0, `MW_${this.reelNumber}_Land`))
            .add(() => {
                this.winAnimation.alpha = 0;
                this.mainSprite.alpha = 1;
                this.moveToNormalLayer();
            })
    }

    private freespinsLand():gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.winAnimation.alpha = 1;
                this.mainSprite.alpha = 0;
                this.moveToWinLayer();
            })
            .add(SpineGSAPWrapper.createTimeline(this.winAnimation, 0, `MW_3_Land`))
            .add(() => {
                this.winAnimation.alpha = 0;
                this.mainSprite.alpha = 1;
                this.moveToNormalLayer();
            })
    }

    public getWinAnimation():gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.winAnimation.alpha = 1;
                this.moveToWinLayer();
            })
            .add(SpineGSAPWrapper.createTimeline(this.winAnimation, 0, `MW_${this.reelNumber}_Win`))
            .add(() => {
                this.winAnimation.alpha = 0;
                this.moveToNormalLayer();
            })
    }
}